import React, { Component } from "react"
import { isMobile } from "react-device-detect"
import TruncateMarkup from "react-truncate-markup"
import reactStringReplace from "react-string-replace"

export default class TypeaheadSearchResults extends Component {
  stringReplace = (text, input) => {
    const words = input.split(" ").filter(Boolean)
    const regex = new RegExp("(" + words.join("*|") + ")", "gi")
    return reactStringReplace(text, regex, (match, i) => <strong key={match + i}>{match}</strong>)
  }

  render() {
    var noResults = (
      <div className="search-result-container__inner">
        <div className="form__section__inner">
          <div className="form__field  no-results">
            <p data-epi-edit="NoResults">{this.props.noResults || "Ingen resultater..."}</p>
          </div>
        </div>
      </div>
    )

    if (this.props.data && this.props.data.count === 0) {
      return noResults
    } else if (!this.props.data) {
      return ""
    }
    const maxLines = isMobile ? 2 : 3
    return (
      <div className="search-result-container__inner">
        {this.props.data?.docs?.map((article, index) => {
          const subheading = this.stringReplace(article.Subheading_s, this.props.query)
          return (
            <a href={article.PageUrl_s} key={index}>
              <div className="form__section__inner">
                <div className="form__field">
                  <p className="section-title">{article.Header_s}</p>
                  <TruncateMarkup lines={maxLines} ellipsis={"..."}>
                    <p className="section-subheading">{subheading}</p>
                  </TruncateMarkup>
                </div>
              </div>
            </a>
          )
        })}
      </div>
    )
  }
}
